import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import Raven from 'raven-js';
import routes from './routes';
import store from './store';

import './index.scss';

Raven.config(process.env.SENTRY_CONFIG_URL, process.env.SENTRY_CONFIG).install();

const history = syncHistoryWithStore(browserHistory, store);

const childRoutes = routes(store);

const onUpdate = () => {
    // Scroll to the top of the page if there's no hash in the URL
    const currentLocation = history.getCurrentLocation();
    if (currentLocation.hash === "") {
        window.scrollTo(0, 0);
    }
};

render(
  <Provider store={store}>
    <Router key="rec-app" history={history} onUpdate={onUpdate}>
      {childRoutes}
    </Router>
  </Provider>,
  document.getElementById('recApp')
);
